import { Input, Icon } from '#app/ui/components'

type SearchInputProps = {
	value: string
	onChange: (value: string) => void
	placeholder?: string
}

export function SearchInput({
	value,
	onChange,
	placeholder = `Search events, venues, or artists...`,
}: SearchInputProps) {
	return (
		<div className="relative flex-1">
			<Icon
				name="magnifying-glass"
				className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-brand-muted-amethyst"
			/>
			<Input
				type="text"
				placeholder={placeholder}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="pl-10 pr-10"
			/>
			{value && (
				<Icon
					name="cross-2"
					className="absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 cursor-pointer text-brand-muted-amethyst hover:text-white"
					onClick={() => onChange(``)}
				/>
			)}
		</div>
	)
}
